import React, {
  useRef,
  useState,
  useEffect,
  useLayoutEffect,
  useCallback,
} from "react";
import "./EcoSysSecFour.css";
import { HashLink as Link } from "react-router-hash-link";
import BeforeImg from "../EcoSysImages/Before_Girl.png";
import AfterImg from "../EcoSysImages/After_Girl.png";
import Star from "../EcoSysImages/star.png";
import Ellipse from "../EcoSysImages/Ellipse2.png";

export default function EcoSectionFour() {
  const [sliderPos, setSliderPos] = useState(50);
  const sliderRef = useRef(null);
  const canvasRef = useRef(null);
  const dragging = useRef(false);
  const beforeImgRef = useRef(null);
  const afterImgRef = useRef(null);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    const before = new Image();
    const after = new Image();
    before.src = BeforeImg;
    after.src = AfterImg;
    let count = 0;
    const handle = () => {
      count += 1;
      if (count === 2) {
        beforeImgRef.current = before;
        afterImgRef.current = after;
        setImagesLoaded(true);
      }
    };
    before.onload = handle;
    after.onload = handle;
    if (before.complete) before.onload();
    if (after.complete) after.onload();
  }, []);

  const updatePosFromEvent = (e) => {
    if (!sliderRef.current) return;
    const rect = sliderRef.current.getBoundingClientRect();
    const point = e.touches ? e.touches[0] : e;
    if (!point) return;
    let x = point.clientX - rect.left;
    x = Math.max(0, Math.min(rect.width, x));
    setSliderPos((x / rect.width) * 100);
  };

  const startDrag = (e) => {
    dragging.current = true;
    updatePosFromEvent(e);
  };
  const stopDrag = () => {
    dragging.current = false;
  };
  const onDrag = (e) => {
    if (dragging.current) updatePosFromEvent(e);
  };

  useEffect(() => {
    const move = (e) => onDrag(e);
    const up = () => stopDrag();
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: false });
    window.addEventListener("mouseup", up);
    window.addEventListener("touchend", up);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("touchmove", move);
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchend", up);
    };
  }, []);

  const drawCover = useCallback((ctx, img, w, h) => {
    if (!img || !img.width || !img.height) return;
    const canvasRatio = w / h;
    const imgRatio = img.width / img.height;
    let drawW, drawH, offsetX, offsetY;
    if (imgRatio > canvasRatio) {
      drawH = h;
      drawW = imgRatio * h;
      offsetX = (w - drawW) / 2;
      offsetY = 0;
    } else {
      drawW = w;
      drawH = w / imgRatio;
      offsetX = 0;
      offsetY = (h - drawH) / 2;
    }
    ctx.drawImage(img, offsetX, offsetY, drawW, drawH);
  }, []);

  const draw = useCallback(() => {
    if (!imagesLoaded || !canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const w = canvas.width;
    const h = canvas.height;
    ctx.clearRect(0, 0, w, h);
    drawCover(ctx, afterImgRef.current, w, h);
    ctx.save();
    ctx.beginPath();
    ctx.rect(0, 0, (sliderPos / 100) * w, h);
    ctx.clip();
    drawCover(ctx, beforeImgRef.current, w, h);
    ctx.restore();
  }, [imagesLoaded, sliderPos, drawCover]);

  useLayoutEffect(() => {
    if (!sliderRef.current || !canvasRef.current) return;
    const canvas = canvasRef.current;
    const resize = () => {
      const rect = sliderRef.current.getBoundingClientRect();

      canvas.width = rect.width * window.devicePixelRatio;
      canvas.height = rect.height * window.devicePixelRatio;
      canvas.style.width = rect.width + "px";
      canvas.style.height = rect.height + "px";
      draw();
    };
    const ro = new ResizeObserver(resize);
    ro.observe(sliderRef.current);
    resize();
    return () => ro.disconnect();
  }, [imagesLoaded, draw]);

  useEffect(() => {
    draw();
  }, [draw]);

  return (
    <section className="section-four-bg">
      <div className="section-four-container">
        <div className="section-four-left">
          <div className="section-four-step">
            04 <span className="section-four-step-total">/05</span>
          </div>
          <h2 className="section-four-title">Level Up With AI</h2>
          <div className="section-four-sub">Turn ideas into visuals—fast.</div>
          <ul className="section-four-list">
            <li>
              {" "}
              <img src={Star} alt="star" className="star-icon" /> One-tap
              presets with fine controls and history.
            </li>
            <li>
              {" "}
              <img src={Star} alt="star" className="star-icon" /> Try portrait
              cleanups, outfit swaps, and poster looks.
            </li>
            <li>
              {" "}
              <img src={Star} alt="star" className="star-icon" /> Private and
              secure—you’re in control of your data.
            </li>
          </ul>
          {/* <button className="section-four-btn">Get Started</button> */}
          <div className="eco-four-section-button">
            <Link to="/#get3voApp" onClick={() => window.scrollTo(0, 0)}>
              <div className="create-token-btn-eco">
                <p className="create-token-btn-text">Get Started</p>
              </div>
            </Link>
          </div>
        </div>
        <div className="section-four-right">
          <div className="section-four-tabs">
            <button className="tab ">Portrait cleanup</button>
            <button className="tab">Outfit swap</button>
            <button className="tab">Poster look</button>
          </div>
          <div className="ellipse-bg-wrapper">
            <img
              src={Ellipse}
              alt="Ellipse background"
              className="ellipse-bg"
            />
            <div
              className="slider-container"
              ref={sliderRef}
              onMouseDown={startDrag}
              onTouchStart={startDrag}
            >
              <canvas ref={canvasRef} className="slider-canvas" />
              <div
                className="slider-divider"
                style={{ left: `${sliderPos}%` }}
              />
              <div
                className="slider-handle"
                style={{ left: `${sliderPos}%`, top: "90%" }}
                onMouseDown={startDrag}
                onTouchStart={startDrag}
              >
                <span className="slider-arrow-left">&#60;</span>
                <span className="slider-arrow-right">&#62;</span>
              </div>
            </div>
            <div className="slider-captions">
              <span className="slider-caption-left">Before</span>
              <span className="slider-caption-right">After</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
